import { apiCap } from '@gik/api';
import { useTaxonomies } from '@gik/api/give/taxonomies';
import { FetchProvider } from '@gik/core/components/DynamicComponent/FetchProvider';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import React from 'react';
import type { RecipientsGridProps } from '.';
import { RecipientsGrid, RecipientsGridSkeleton } from '.';

function RecipientsGridWithDataComp(props: RecipientsGridProps) {
  const { items } = props;

  const useFetch = () => {
    return useTaxonomies(
      'recipient',
      { page: 1, perPage: apiCap },
      {
        fallbackData: items,
      }
    );
  };

  return (
    <FetchProvider fetch={useFetch} loadingComponent={<RecipientsGridSkeleton {...props} />}>
      {({ data }) => <RecipientsGrid {...props} items={data} />}
    </FetchProvider>
  );
}

export const RecipientsGridWithData = withComponentErrorBoundary(RecipientsGridWithDataComp);
